module.exports = __webpack_public_path__ + "img/Beispiel-Contenbild_4spaltig.dbd0925f.jpg";